module.exports = __webpack_public_path__ + "static/media/logo.a14bea93.svg";